import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { Download } from 'lucide-react';

const HeaderSection = ({ handleBack, selectedApp }) => {
    return (
        <div className="d-flex justify-content-between align-items-center top-header border-bottom border-secondary pb-3 mb-4">
            <div className="d-flex align-items-center gap-4">
                <button className="btn btn-outline-light btn-sm" onClick={handleBack}>
                    <FaArrowLeft className="me-1"/> Back
                </button>
                
                <div className="border-start border-secondary ps-4">
                    <h4 className="fw-bold mb-1">
                        {String(selectedApp.bookingType || "").toUpperCase() === "VIDEO_UPLOAD" 
                            ? "AI Audition Analysis & Casting Match Report" 
                            : "Audition Booking & Meeting Details"}
                    </h4>
                    <div className="text-muted" style={{fontSize: '0.85rem'}}>
                        Project: <span className="text-white">{selectedApp.c_project_name}</span> | Role: <span className="text-white">{selectedApp.c_role_name}</span> | Mode: <span className="text-danger fw-bold">{selectedApp.bookingType}</span>
                    </div>
                </div>
            </div>
           
        </div>
    );
};

export default HeaderSection;